import React from 'react';
import { Card, CardBody } from 'reactstrap';
import { Switch, Route, NavLink } from 'react-router-dom';

import StateReportContainer from './StateReportContainer';
import EmployeeExposureContainer from './employee-exposure/EmployeeExposureContainer';

const ReportsLayout = () => {
  return (
    <div className="ReportsLayout">
      <div className="ReportsLayout__header">
        <h3 className="section-title">Reports</h3>

        <ul className="nav nav-tabs card-nav-tabs">
          <li className="nav-item">
            <NavLink
              className="nav-link"
              to="/reports/state"
            >
              State
            </NavLink>
          </li>

          <li className="nav-item">
            <NavLink
              className="nav-link"
              to="/reports/employee-exposure"
            >
              Employee Exposure
            </NavLink>
          </li>
        </ul>
      </div>

      <Card className="minimal">
        <CardBody>
          <Switch>
            <Route exact path="/reports/state" component={StateReportContainer} />
            <Route exact path="/reports/employee-exposure" component={EmployeeExposureContainer} />
          </Switch>
        </CardBody>
      </Card>
    </div>
  );
};

export default ReportsLayout;



// WEBPACK FOOTER //
// ./src/features/reports/ReportsLayout.js